import _ from 'lodash';
import moment from 'moment-timezone';

import { ReferralStatus } from './constants';
import { validatePatientReferral } from './validators';

export const extractPatientReferral = (referral) => ({
  id: referral.id,
  referralType: referral.referralType,
  status: referral.status,
  dateSent: referral.dateSent,
  preferredLocation: referral.preferredLocation,
  otherLocation: referral.otherLocation ?? '',
  patientId: referral.patientId,
});

export const getInitialReferralData = (patientId) => ({
  patientId,
  referralType: null,
  status: ReferralStatus.Sent,
  dateSent: moment().format('YYYY-MM-DD'),
  preferredLocation: null,
  otherLocation: '',
});

export const catchReferralErrors = (formData) => {
  const errors = {};
  formData.forEach((referral, i) => {
    if (!referral.patientId) return;
    Object.entries(referral).forEach(([field, value]) => {
      const err = validatePatientReferral(field, value, referral);
      if (err[field]) {
        Object.assign(errors, { [`${i}.${field}`]: err[field] });
      }
    });
  });

  return {
    errors,
    hasErrors: !_.isEmpty(errors) || Object.values(errors).some((e) => e),
  };
};

export const hasDuplicateReferrals = (formData) => {
  const uniqueReferrals = _.uniqBy(
    formData,
    (referral) =>
      `${referral.referralType}-${referral.status}-${referral.dateSent}-${referral.preferredLocation}`,
  );

  return uniqueReferrals.length !== formData.length;
};

export const getReferralsModuleData = (formData, referrals) => {
  const requests = {
    referral_creations: [],
    referral_updates: [],
    referral_deletions: [],
  };

  if (!Array.isArray(referrals) || !Array.isArray(formData)) return requests;

  const oldReferrals = referrals.map((referral) => extractPatientReferral(referral));

  if (_.isEqual(formData, oldReferrals)) {
    return requests;
  }

  formData.forEach((referral) => {
    const referralExists = oldReferrals.find(({ id }) => id === referral.id);

    if (!referralExists) {
      requests.referral_creations.push(_.omit(referral, ['id']));
      return;
    }

    if (!_.isEqual(referral, referralExists)) {
      requests.referral_updates.push(referral);
    }
  });

  oldReferrals.forEach(({ id }) => {
    const referralExists = formData.find((referral) => referral.id === id);

    if (!referralExists) {
      requests.referral_deletions.push(id);
    }
  });

  return requests;
};
